const actions = {
  SET_STATE: 'integration/SET_STATE',
  LOAD: 'integration/LOAD',
}

export default actions
